import React from 'react';

export const RoundCallSuccess: React.FC = () => {
	return (
		<svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M0 36C0 16.1178 16.1178 0 36 0C55.8823 0 72 16.1178 72 36C72 55.8823 55.8823 72 36 72C16.1178 72 0 55.8823 0 36Z"
				fill="#8AC9DB"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M31.7705 39.3525L25.6614 33.2433C24.2376 31.8195 21.9291 31.8195 20.5054 33.2433C19.0816 34.6671 19.0816 36.9755 20.5054 38.3993L29.2049 47.0989C30.6287 48.5227 32.9371 48.5227 34.3609 47.0989C34.4695 46.9903 34.5701 46.8761 34.6627 46.757C34.6986 46.7241 34.7338 46.6904 34.7685 46.6559L51.4341 30.0723C52.8613 28.6521 52.867 26.3437 51.4468 24.9164C50.0265 23.4891 47.7181 23.4834 46.2908 24.9036L31.7705 39.3525Z"
				fill="white"
			/>
		</svg>
	);
};
